module.exports = __webpack_public_path__ + "assets/media/day33.80ba7650.mp3";